module.exports = __webpack_public_path__ + "img/logo.1e9c61f4.png";